module.exports = __webpack_public_path__ + "img/ma.aa50603f.svg";